<template>
    <div style="margin-top: 50px">
        <div v-for="(projectCaseItem,index) in projectCase" :key="index + 'projectCase'" >
            <div v-if="projectCaseItem.id % 2 !== 0" class="content">
                <div class="photo">
                    <img :src="projectCaseItem.img.src" alt="">
                </div>
                
                <div class="container">
                    <h2>{{projectCaseItem.title}}</h2>
                    <p>&nbsp; &nbsp;&nbsp;&nbsp; {{projectCaseItem.text}}</p>
                </div>
            </div>
            <div v-else class="content">
                <div class="container">
                    <h2>{{projectCaseItem.title}}</h2>
                    <p>&nbsp; &nbsp;&nbsp;&nbsp; {{projectCaseItem.text}}</p>
                </div>
                <div class="photo">
                    <img :src="projectCaseItem.img.src" alt="">
                </div>
            </div>
            
        </div>
    </div>
</template>

<script>
import { projectCase } from '@/view/project.js';
export default {
    name:'ProjectPage',
    data() {
    return {
        projectCase
    };
  },
}
</script>

<style scoped>
.content {
   width: 1340px;
    margin: auto;
    display: flex;
    justify-content: space-around;
    align-items: center;
    text-align: left;
    line-height: 30px;
    color: #666666;
}
.photo {
    width: 50%;
    height: auto;
}
.photo img {
    width: 100%;
    height: auto;
}
.container {
    width: 50%;
}
.container h2, p {
    margin: 30px;
} 
</style>